import React from 'react';
export default function LoadingIndicator({ label='Loading...', size=14, inline=true }) {
  return (
    <div style={{ display:inline ? 'inline-flex' : 'flex', alignItems:'center', gap:8, fontSize:'0.85rem' }}>
      <span style={{ width:size, height:size, border:'2px solid var(--color-primary)', borderBottomColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.8s linear infinite' }} />
      {label ? <span>{label}</span> : null}
    </div>
  );
}
